import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=376737b4&scoped=true&"
import script from "./blogDetail.vue?vue&type=script&lang=js&"
export * from "./blogDetail.vue?vue&type=script&lang=js&"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=376737b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376737b4",
  null
  
)

export default component.exports